import React, { useEffect, useState } from "react";
import { FiEdit2, FiImage, FiPlus, FiTrash2, FiX, FiSave, FiUpload } from "react-icons/fi";
import { supabase } from "../supabaseClient";

function AboutFour() {
  const [team, setTeam] = useState([]);
  const [modal, setModal] = useState(null);
  const [name, setName] = useState("");
  const [role, setRole] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    const getTeam = async () => {
      const res = await supabase.from("AboutFour").select("*");
      setTeam(res.data);
    };
    getTeam();
  }, []);

  const openCreate = () => {
    setName("");
    setRole("");
    setImageUrl("");
    setModal({ mode: "create" });
  };

  const openEdit = (m) => {
    setName(m.name);
    setRole(m.role);
    setImageUrl(m.image_url ?? "");
    setModal({ mode: "edit", id: m.id });
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    const fileName = `team-${Date.now()}-${file.name}`;
    await supabase.storage.from("images").upload(fileName, file);
    const { data } = supabase.storage.from("images").getPublicUrl(fileName);
    setImageUrl(data.publicUrl);
    setUploading(false);
  };

  const saveMember = async () => {
    if (!name.trim()) return;
    if (modal.mode === "create") {
      const res = await supabase
        .from("AboutFour")
        .insert([{ name: name.trim(), role: role.trim(), image_url: imageUrl || null }])
        .select();
      setTeam((prev) => [...prev, res.data[0]]);
    } else {
      await supabase
        .from("AboutFour")
        .update({ name: name.trim(), role: role.trim(), image_url: imageUrl || null })
        .eq("id", modal.id);
      setTeam((prev) =>
        prev.map((m) =>
          m.id === modal.id ? { ...m, name: name.trim(), role: role.trim(), image_url: imageUrl || null } : m
        )
      );
    }
    setModal(null);
  };

  const deleteMember = async (id) => {
    await supabase.from("AboutFour").delete().eq("id", id);
    setTeam((prev) => prev.filter((m) => m.id !== id));
  };

  return (
    <section className="about-card">
      <div className="about-card__head">
        <h2 className="about-card__title">Team Members</h2>
        <button type="button" className="about-btn" onClick={openCreate}>
          <FiPlus aria-hidden />
          Add Team Member
        </button>
      </div>
      <div className="about-team-grid">
        {team.map((m) => (
          <article key={m.id} className="about-team-card">
            <div className="about-icon-actions">
              <button type="button" className="about-icon-btn about-icon-btn--edit" aria-label={`Edit ${m.name}`} onClick={() => openEdit(m)}>
                <FiEdit2 />
              </button>
              <button type="button" className="about-icon-btn about-icon-btn--del" aria-label={`Remove ${m.name}`} onClick={() => deleteMember(m.id)}>
                <FiTrash2 />
              </button>
            </div>
            <div className="about-team-photo" aria-hidden>
              {m.image_url ? <img src={m.image_url} alt={m.name} style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "inherit" }} /> : <FiImage />}
            </div>
            <h3 className="about-team-name">{m.name}</h3>
            <p className="about-team-role">{m.role}</p>
          </article>
        ))}
      </div>

      {modal && (
        <div className="faqs-modal-backdrop" role="presentation" onClick={() => setModal(null)}>
          <div className="faqs-modal" role="dialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
            <div className="faqs-modal__head">
              <h2 className="faqs-modal__title">{modal.mode === "create" ? "Add Team Member" : "Edit Team Member"}</h2>
              <button type="button" className="faqs-icon-btn" onClick={() => setModal(null)} aria-label="Close">
                <FiX />
              </button>
            </div>
            <div className="faqs-modal__form">
              <label className="faqs-field">
                <span className="faqs-field__label">Name</span>
                <input className="faqs-field__input" value={name} onChange={(e) => setName(e.target.value)} placeholder="Full name" autoFocus />
              </label>
              <label className="faqs-field">
                <span className="faqs-field__label">Role</span>
                <input className="faqs-field__input" value={role} onChange={(e) => setRole(e.target.value)} placeholder="Job title" />
              </label>
              <label className="faqs-field">
                <span className="faqs-field__label">Photo</span>
                <label className="about-btn" style={{ cursor: "pointer", display: "inline-flex", alignItems: "center", gap: "0.4rem" }}>
                  <FiUpload aria-hidden />
                  {uploading ? "Uploading…" : imageUrl ? "Change Photo" : "Upload Photo"}
                  <input type="file" accept="image/*" style={{ display: "none" }} onChange={handleImageUpload} />
                </label>
                {imageUrl && <img src={imageUrl} alt="preview" style={{ marginTop: "0.5rem", width: 64, height: 64, objectFit: "cover", borderRadius: "50%" }} />}
              </label>
              <div className="faqs-modal__foot">
                <button type="button" className="faqs-btn faqs-btn--outline" onClick={() => setModal(null)}>Cancel</button>
                <button type="button" className="faqs-btn faqs-btn--primary" onClick={saveMember}>
                  <FiSave aria-hidden /> Save
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}

export default AboutFour;